import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { ObligationsHd, ObligationsList, ObligationsCRU } from '../components';
import { useParams } from 'react-router-dom';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deleteObligationApi, getObligationApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { useSnackbar } from 'notistack';
import { PermissionWrapper } from '../../../../wrappers';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { RoleBaseAccess } from '../../../../hoc';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import { obligationAttachmentMetaData } from '../../contributions/apiService';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const Obligations = () => {
    const dispatch=useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [deleteObligation, setDeleteObligation] = useState({ modal: false, data: null });
    const [addEditObligation, setAddEditObligation] = useState({ mode: '', modal: false, data: null });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [uploadfileList, setUploadfileList] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [obligationInfo, setObligationInfo] = useState({ list: [], pagination: {} });
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse("obligations", slug);
        getObligationList('skeletonLoader', { per_page: 50, });
        trackActivity('Page Viewed',{ page_title: 'Obligations'})
           setUploadFileProgressData({uploadedFileData});
    }, []);

    const getObligationList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);

        globalGetService(getObligationApi(params, query), {}).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setObligationInfo(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        });
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"obligations"}))
    };

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] })
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const onDeleteObligation = () => {
        setLoading(true);
        const idsToDelete = deleteObligation?.modal && deleteObligation?.data?.id ? [deleteObligation?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteObligationApi(params), { ids: idsToDelete })
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Obligation`, success_msg: response?.data?.message, item_ids: deleteObligation?.data || bulk?.ids, response: response?.data })
                    setDeleteObligation({ modal: false, data: null });
                    getObligationList('', {page: obligationInfo?.pagination?.current_page || 1,  per_page: obligationInfo?.pagination?.per_page || 20 });
                    setBulk({ modal: false, ids: [], leaseSlug: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Obligation`, error_msg: response?.data?.message, item_ids: deleteObligation?.data || bulk?.ids, response: response?.data })
                }
            });
    };

    const onDeteAttchments = (deltedslug) => {
        setUploadfileList({
            ...uploadfileList, data: {
                ...uploadfileList.data,
                attachments: uploadfileList.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditObligation?.modal) {
            setAddEditObligation({
                ...addEditObligation,
                data: {
                    ...addEditObligation.data,
                    attachments: addEditObligation.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getObligationList('', { page: obligationInfo?.pagination?.current_page || 1, per_page: obligationInfo?.pagination?.per_page || 50 });
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key }
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getObligationList('', {
            ...sortQuery,
            page: obligationInfo?.pagination?.current_page || 1,
            per_page: obligationInfo?.pagination?.per_page || 20,
        });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getObligationApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

const handleUpload = async (slug) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "obligations",
            slug: slug,
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
               setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getObligationList("fetch", { per_page: obligationInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Obligations`, page_type: page_type, })
    }

    return (
        <>
        <LeasesBasicDetails/>
        <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="technical"/>
            <div className='lease-details-content contnet-overflow'>
                <Paper square className="responsive-paper">
                    <Grid container className="responsive-grid" alignItems="end">
                        <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                            <LeasesMenuList btnText="Obligations" type="technical" />
                        </Grid>
                         <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                    <Grid item size={{ md: 6, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                                <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/></li>
                                {
                                    bulk?.type && bulk?.ids?.length ?
                                        <>
                                            <li className='lease-mobile-button'>
                                                <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button')}} size="small" variant="outlined" color="primary" >Cancel</Button>
                                            </li>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['D'] }}>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button')}} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                        </> : null
                                }
                                {obligationInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15}/> : <ArrowDownwardIcon/>} className='btn-primary action-btn-start-icon' variant="outlined" size='small' onClick={() => { handleExport("xlsx"); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "obligations", operationType: ['C'] }}>
                                    <li className='lease-mobile-button'>
                                        <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" color="primary" onClick={() => { setAddEditObligation({ modal: true, data: null, mode: 'add', }); handleItemClicked('Add Item Button') }}> Add Obligations </Button>
                                    </li>
                                </PermissionWrapper>
                            </ul>
                         </Grid>
                    </Grid>
                </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: obligationInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <ObligationsHd item={obligationInfo?.list} toggleBulkOps={toggleBulkOps} bulk={bulk} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                <TableBody>
                                    {obligationInfo?.list?.length > 0 && obligationInfo?.list.map((item, index) => {
                                         const uploadedFileData = getApiResponse("obligations", item?.slug);

                                        return (
                                            <ObligationsList deleteObligation={deleteObligation}
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                params={params}
                                                addEditObligation={addEditObligation}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onEdit={() => setAddEditObligation({ modal: true, mode: 'edit', data: item })}
                                                onDelete={(e) => {
                                                    setDeleteObligation({ modal: true, data: item });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                onView={() => setAddEditObligation({ modal: true, mode: 'view', data: item })}
                                                viewFile={() => setUploadfileList({ modal: true, mode: 'file', data: item })}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                getResponseBack={() => getObligationList('pageLoader', {page: obligationInfo?.pagination?.current_page || 1,  per_page: obligationInfo?.pagination?.per_page || 20 })}
                                            />
                                        )
                                    }
                                    )}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                    <Paper square>
                        {!skeletonLoader && !obligationInfo?.list?.length && <NoRecordFound />}
                        <Pagination
                            pagination={obligationInfo?.pagination} onPageChange={(event, newPage) => { const pageNum = newPage + 1; getObligationList("Pageloader", { page: pageNum, per_page: obligationInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getObligationList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
            </Paper>
            {
                addEditObligation.modal && <ObligationsCRU
                    params={params}
                    fileUpload={handleUpload}
                    addEditObligation={addEditObligation}
                    modeType={addEditObligation.mode}
                    addEditSupplement={addEditObligation}
                    onOpenAttachments={() => setUploadfileList({ modal: true, data: addEditObligation?.data, mode:'view' })}
                    getResponseBack={() => {getObligationList('pageLoader', {page: obligationInfo?.pagination?.current_page || 1,  per_page: obligationInfo?.pagination?.per_page || 20 }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditObligation({ modal: false, mode: '', data: null })}
                />
            }
            {
                uploadfileList.modal ? <ShowAttachments
                    moduleName="Obligations"
                    url='delete-attachment'
                    attachmentsData={uploadfileList}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setUploadfileList({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditObligation?.mode === 'view' || uploadfileList?.mode==='view'}
                    permissionKey='obligations'
                /> : null
            }

            {deleteObligation.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteObligation.modal}
                    title={`Delete ${bulk?.modal ? (bulk?.ids?.length === (obligationInfo?.list?.length || 0) ? "All Obligations" : "Selected Obligations") : "Obligation"}`}
                    onDeleteRecords={() => onDeleteObligation()}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        } else {
                            setDeleteObligation({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                /> : null}

             {
              revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"obligations"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
             }    
              <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
             />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(Obligations, { application: 'lease_revamp', feature: 'obligations', operationType: ['R'] });
